import { createSelector } from 'reselect';
import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
export const getAttributes = basicSelector(state => state.userAttributes);
export const getAttribute = createSelector([getAttributes, (state, key) => key], (attributes, key) => {
  return attributes[key];
});